var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("SeguimientoListaFicha"),
      _vm._v(" "),
      _c("Reporte"),
      _vm._v(" "),
      _c("RevisarObservarListaFicha"),
      _vm._v(" "),
      _c("HabilitarFicha"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("done")]),
          _vm._v(" Revisión ficha personal\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.filterShow = _vm.filterShow ? false : true
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("filter_list")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Búsqueda/filtros")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return _vm.cargarListadoPersonas()
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
        ],
        1
      ),
      _vm._v(" "),
      _vm.filterShow
        ? _c(
            "v-card",
            { attrs: { color: "#CFE5F8" } },
            [
              _c(
                "v-card-text",
                { staticClass: "sinMargen" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "filtroRRHH",
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs11: "" } }),
                          _vm._v(" "),
                          _c(
                            "v-tooltip",
                            { attrs: { bottom: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    icon: "",
                                    color: "#DDC2DF"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.recargar()
                                    }
                                  },
                                  slot: "activator"
                                },
                                [_c("v-icon", [_vm._v("refresh")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("Recargar filtros")])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs1: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { slot: "activator", icon: "" },
                                  slot: "activator"
                                },
                                [_c("v-icon", [_vm._v("search")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nro. documento",
                                  type: "text"
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filterNroDoc(_vm.form.nro_doc)
                                  }
                                },
                                model: {
                                  value: _vm.form.nro_doc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nro_doc", $$v)
                                  },
                                  expression: "form.nro_doc"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Item", type: "number" },
                                on: {
                                  input: function($event) {
                                    return _vm.filterItem(_vm.form.item)
                                  }
                                },
                                model: {
                                  value: _vm.form.item,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "item", $$v)
                                  },
                                  expression: "form.item"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Nombre" },
                                on: {
                                  input: function($event) {
                                    return _vm.filterNombre(_vm.form.nombre)
                                  }
                                },
                                model: {
                                  value: _vm.form.nombre,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nombre", $$v)
                                  },
                                  expression: "form.nombre"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Unidad", type: "text" },
                                on: {
                                  input: function($event) {
                                    return _vm.filterUnidad(_vm.form.unidad)
                                  }
                                },
                                model: {
                                  value: _vm.form.unidad,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "unidad", $$v)
                                  },
                                  expression: "form.unidad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: { label: "Estado", type: "text" },
                                on: {
                                  input: function($event) {
                                    return _vm.filterEstadoFicha(
                                      _vm.form.estado_ficha
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.estado_ficha,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "estado_ficha", $$v)
                                  },
                                  expression: "form.estado_ficha"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("br")
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-data-table",
                {
                  staticClass: "elevation-1",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.lista_fichas,
                    "no-data-text": _vm.loading
                      ? "Cargando..."
                      : "No se tiene registros",
                    "disable-initial-sort": true,
                    loading: _vm.loading,
                    "no-results-text": "No se encontraron coincidencias",
                    "item-key": "index",
                    search: _vm.filters,
                    "custom-filter": _vm.customFilter,
                    "rows-per-page-items": [
                      20,
                      40,
                      { text: "Todos", value: -1 }
                    ]
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nro_doc))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.item))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.nombre))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.unidad))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.estado_ficha))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(_vm._s(items.item.observacion))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "nowrap text-xs-center" }),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "nowrap text-xs-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "info" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.HabilitarFicha(items.item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              Habilitar\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              items.item.id_estado_ficha != 38
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "info",
                                        to:
                                          "/personas/ficha-personal/" +
                                          items.item.id_persona
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Modificar\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    slot: "activator",
                                    depressed: "",
                                    color: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.reporte(items.item.id_persona)
                                    }
                                  },
                                  slot: "activator"
                                },
                                [
                                  _vm._v(
                                    "\n              Ver Ficha Personal\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              items.item.id_estado_ficha == 36 ||
                              items.item.id_estado_ficha == 37 ||
                              items.item.id_estado_ficha == 40
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "success" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.RevisarObservarListaFicha(
                                            items.item
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Revisar\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              items.item.id_estado_ficha != 39
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        title: "Ver seguimiento",
                                        icon: "",
                                        color: "info"
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.SeguimientoListaFicha(
                                            items.item
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("remove_red_eye")])],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [_c("template", { slot: "buttons" })],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db57399c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db57399c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/v_listaficha/Index.vue
// module id = null
// module chunks = 